export const beforeLogout = () => {
  sessionStorage.clear()
  window.location.reload()
}

export default beforeLogout
